import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const exportToExcel = (tableData, reportName = "ExportedReport") => {
  if (!tableData || tableData.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "No Data",
      text: "There is no data to export.",
    });
    return;
  }

  // 🔹 Auto-detect all keys dynamically
  const formattedData = tableData.map((item, index) => {
    const flatItem = {};
    flatItem["Sl No."] = index + 1;
    // Flatten nested objects for better readability
    const flattenObject = (obj, parentKey = "") => {
      for (let key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          flattenObject(obj[key], `${parentKey}${key}_`);
        } else {
          flatItem[`${parentKey}${key}`] = obj[key];
        }
      }
    };

    flattenObject(item);
    // flatItem["Sl No."] = index + 1;
    return flatItem;
  });

  // 🔹 Convert JSON to worksheet
  const worksheet = XLSX.utils.json_to_sheet(formattedData);

  // 🔹 Set dynamic column widths
  const columnWidths = Object.keys(formattedData[0]).map((key) => ({
    width:
      Math.max(
        key.length,
        ...formattedData.map((row) => row[key]?.toString().length || 0)
      ) + 2,
  }));
  worksheet["!cols"] = columnWidths;

  // 🔹 Create workbook and export
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, `${reportName}.xlsx`);

  Swal.fire({
    icon: "success",
    title: "Export Complete!",
    text: `${reportName}.xlsx downloaded successfully.`,
  });
};

export default exportToExcel;
